<template>
   <div style="width:100%">
        <div class="layer1">
          <div class="info1">实验编号：{{contractNo}}</div>
          <div class="box3" :class="getStatusClass(status)">{{status}}</div>
    </div>
    <div class="layer2"></div>
   </div>
</template>
<script>
// import EMKT from '../../../emkt.js'
import {serviceProgressMixIn} from '@/views_v_2.6/PrivateMixins/ProgressMixin.js'
export default {
  mixins: [serviceProgressMixIn],
  props: {
    contractNo: String,
    status: String
  },
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {
  }
}
</script>

<style scoped>
.layer1 {
  height: 45px;
  margin-left: 15px;
  width: 100%;
  margin-left: 15px;
  display: flex;
  justify-content: space-between;
}

.info1 {
  width: 136px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(66, 66, 66, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  text-align: left;
  line-height: 45px;
}

.box3 {
  width: 45px;
  height: 15px;
  display: block;
    overflow-wrap: break-word;
    font-size: 10px;
    white-space: nowrap;
    line-height: 15px;
    text-align: center;
    margin-left: 3px;
  background: #FF9400;
  border-radius: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #FFFFFF;
  text-align: center;
  margin-right: 25px;
  margin-top: 13.5px;
}
.layer2 {
  width: 100%;
  height: 1px;
  background: url(/static/img/SketchPngc23a87c8cf46a02bf5caeda53083f8505a8cc76dd04bb2461e56e50d60186783.png)
    100% no-repeat;
    /* border-top: 1px solid #e7e7e7; */
}
.mod1 {
  border-radius: 7.5px 7.5px 7.5px 7.5px;
  background-color: rgba(255, 148, 0, 1);
}
.layer6 {
  border-radius: 7.5px 7.5px 7.5px 7.5px;
  background-color: rgba(96, 216, 55, 1);
}
.layer7 {
  border-radius: 7.5px 7.5px 7.5px 7.5px;
  background-color:   #FE654D;
}
.layer5 {
  border-radius: 7.5px 7.5px 7.5px 7.5px;
  background-color: rgba(151, 151, 151, 1);
}
</style>



// WEBPACK FOOTER //
// ExperimentHeader.vue?3c0b4418